import { query } from '@confluence/query-preloader-tools';

import { preloadOptions } from '../Options/preloadOptions';

import { getDraftsQueryOptions } from './draftsQueryHelpers';

export const preloadDrafts = ({ isLoggedIn }) => {
	return Promise.all([query(getDraftsQueryOptions({})), preloadOptions({ isLoggedIn })]);
};
